/* Generated USDT deposit components unit. */
import React from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { convertedUsdt } from '../helpers/depositMode.helper';
export const ManualUsdtDeposit = ({ policy, amount, onCopyAddress }) => (
  <section className="wallet-usdt-panel" aria-label="수동 USDT 입금">
    <div className="wallet-usdt-panel-head"><div><span>본사 USDT 입금 주소</span><strong>TRC-20 네트워크</strong></div></div>
    {policy.ready ? <>
      <div className="wallet-usdt-address"><label htmlFor="wallet-manual-usdt-address">입금 주소</label>
        <div className="wallet-copyline"><input id="wallet-manual-usdt-address" value={policy.address} readOnly />
          <button type="button" onClick={() => onCopyAddress(policy.address)}>복사</button></div></div>
      <div className="wallet-usdt-qr"><QRCodeSVG value={policy.address} size={112} level="M" title="본사 USDT 입금 주소 QR 코드" /></div>
      <div className="wallet-usdt-rate"><span>USDT 환산</span><strong>{convertedUsdt(amount, policy.rate)} USDT</strong></div>
      <p className="wallet-usdt-warning">TRC-20 주소로 전송한 후 원화 금액으로 입금을 신청해주세요.</p>
    </> : <p className="wallet-usdt-empty is-error" role="status">{policy.error || '입금 주소와 환율을 확인할 수 없습니다. 잠시 후 다시 시도해주세요.'}</p>}
  </section>
);
